import { ICommonCdGroup, IMain, IServiceControl } from 'src/@types/apiResponse';
import { ICodeGroupModel, ICommonCd } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/* 전체 공통 코드 목록 조회 (스웨거 명세: GET /v1/code) */
export const getCommonCds = async () => {
  try {
    const url = `/v1/code`;
    const response = await instance.get<TApiResponseData<ICodeGroupModel[]>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }

    return [];
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Common] getCommonCds failed:', error);
    }
  }
};

/* 자식 코드 목록 조회 (스웨거 명세: GET /v1/code?cdPid={cdPid}) */
export const getCommonCd = async (cdPid: number | string) => {
  try {
    const url = `/v1/code`;
    const response = await instance.get<TApiResponseData<ICommonCd[]>>(url, {
      params: { cdPid },
    });
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Common] getCommonCd failed:', error);
    }
  }
};

/* 자식 코드 그룹 목록 조회 */
export const getCommonCdGroup = async (cdPid: number | string) => {
  try {
    const url = `/v1/code`;
    const response = await instance.get<TApiResponseData<ICommonCdGroup[]>>(url, {
      params: { cdPid },
    });
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Common] getCommonCdGroup failed:', error);
    }
  }
};

/* 홈 화면 조회 */
export const getMain = async () => {
  try {
    const url = `/v1/user/main`;
    const response = await instance.get<TApiResponseData<IMain>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Common] getMain failed:', error);
    }
  }
};

/* 서비스 제어 */
export const getServiceControl = async (page: string) => {
  try {
    const url = `/v1/serviceControl/${page}`;
    const response = await instance.get<TApiResponseData<IServiceControl>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Common] getServiceControl failed:', error);
    }
  }
};
